import { graphql, useFragment } from "react-relay";
import { EmployeeAvatar, FilterButton, useCircleSize } from "arkh";
import React from "react";
import { FilterButtonMe_employee$key } from "./__generated__/FilterButtonMe_employee.graphql";
import { FormattedMessage } from "react-intl";

export function FilterButtonMe(props: {
  employee: FilterButtonMe_employee$key | null;
  isSelected: boolean;
  onSetSelected: (selected: boolean) => void;
}) {
  const avatar = useFragment(
    graphql`
      fragment FilterButtonMe_employee on Employee {
        id
        ...Avatar_employee
      }
    `,
    props.employee
  );

  const label = (
    <FormattedMessage
      defaultMessage="Assigned to me"
      description="Label for the filter button that shows tasks assigned to the current user."
    />
  );
  const indicatorSize = useCircleSize("smallMedium");
  const indicator = <EmployeeAvatar employee={avatar ?? null} size="small" />;
  if (!props.isSelected) {
    return (
      <FilterButton
        mode="inactive"
        onPress={() => {
          props.onSetSelected(true);
        }}
        indicatorComponent={indicator}
        indicatorSize={indicatorSize}
      >
        {label}
      </FilterButton>
    );
  }
  return (
    <FilterButton
      mode="active"
      onPress={() => {
        props.onSetSelected(false);
      }}
      isPlural={false}
      indicatorSize={indicatorSize}
      indicatorComponent={indicator}
    >
      {label}
    </FilterButton>
  );
}
